function calculateVapeDuty( dutyPerMl, bottlePrice, bottleVolume, bottleQty, addNicshot, nicshotVolume, nicShotQty )
{
    if ( ( isNaN( dutyPerMl ) || isNaN( bottlePrice ) || isNaN( bottleVolume ) || isNaN( bottleQty ) || isNaN( nicshotVolume ) || isNaN( nicShotQty ) ) )
    {
        return {
            "totalDuty"                : 0,
            "totalBeforeDutyBeforeTax" : 0,
            "totalAfterDutyBeforeTax"  : 0,
            "totalAfterDutyAfterTax"   : 0
        };
    }

    var totalVolume = bottleVolume * bottleQty;
    if ( addNicshot && nicshotVolume && nicShotQty )
    {
        totalVolume = totalVolume + bottleQty * nicshotVolume * nicShotQty;
    }

    var totalDuty                = dutyPerMl * totalVolume;
    var totalBeforeDutyBeforeTax = bottlePrice * bottleQty;
    var totalAfterDutyBeforeTax  = totalBeforeDutyBeforeTax + totalDuty;
    var totalAfterDutyAfterTax   = totalAfterDutyBeforeTax * 1.2;

    return {
        "totalDuty"                : totalDuty,
        "totalBeforeDutyBeforeTax" : totalBeforeDutyBeforeTax,
        "totalAfterDutyBeforeTax"  : totalAfterDutyBeforeTax,
        "totalAfterDutyAfterTax"   : totalAfterDutyAfterTax
    };
}

function initVapeDutyCalculator( )
{
    var formatter = new Intl.NumberFormat( "en-GB", { style: "currency", currency: "GBP" } );

    document.querySelectorAll( ".duty-calc" ).forEach( function( dutyContainer )
    {
        if ( dutyContainer._vdInit )
        {
            return;
        }
        dutyContainer._vdInit = true;
        var subExVatRow = dutyContainer.querySelector(".js-output__subtotal-ex-vat");
        if (subExVatRow) 
        { 
          subExVatRow.closest(".output__line").style.display = "none";        
        }
        var tabs           = dutyContainer.querySelectorAll( ".js-duty-calc-tab" );
        var form           = dutyContainer.querySelector( ".js-duty-calc-form" );
        var nicToggleLabel = dutyContainer.querySelector( ".js-nic-toggle" );
        var nicForm        = dutyContainer.querySelector( ".js-nic-shots-form" );
        var inputs         = dutyContainer.querySelectorAll( "input" );
        var addNicShotEl   = dutyContainer.querySelector( "#nic-shots" );
       
        if ( !form || tabs.length < 0 ) return;

		function updateVapeDutyCalculator( e )
		{

			var tab = dutyContainer.querySelector( `.js-duty-calc-tab[ data-type="${ form.dataset.activeType }" ]` );
			if ( !tab ) return;

			if ( addNicShotEl.checked && tab.dataset.addNicShots === "true" )
			{
				nicForm.style.height = nicForm.scrollHeight + "px";
				nicForm.classList.add( "form__nic-shots--active" );
			}
			else
			{
				nicForm.style.height = 0;
				nicForm.classList.remove( "form__nic-shots--active" );
			}

			var dutyPerMl     = dutyContainer.dataset.dutyPerMl;
			if ( isNaN( tab.dataset.price ) )
			{
				return;
			}
			var basePrice     = parseFloat( tab.dataset.price ) / 1.2;
			var bottleVolume  = tab.dataset.size;
			var bottleQty     = form.querySelector( "#quantity" ).value;
			var addNicShot    = tab.dataset.addNicShots === "true" && addNicShotEl.checked == true;
			var nicshotVolume = form.querySelector( "#nic-shot-size" ).value;
			var nicShotQty    = form.querySelector( "#nic-shots-per-shortfill" ).value;

			var results = calculateVapeDuty( dutyPerMl, basePrice, bottleVolume, bottleQty, addNicShot, nicshotVolume, nicShotQty );
			
			dutyContainer.querySelector(".js-output__base-amount").textContent        = formatter.format((results.totalBeforeDutyBeforeTax * 1.2) / 100);
			dutyContainer.querySelector(".js-output__duty-amount").textContent        = formatter.format((results.totalDuty * 1.2) / 100); 
			dutyContainer.querySelector( ".js-output__subtotal-inc-vat" ).textContent = formatter.format( results.totalAfterDutyAfterTax / 100 );
			dutyContainer.querySelector( ".js-selected-bottle-size" ).textContent     = bottleVolume + "mL";

		}

		tabs.forEach( tab =>
		{
			tab.addEventListener( "click", function( )
			{
				form.dataset.activeType = tab.dataset.type;
				tabs.forEach( currTab => currTab.classList.remove( "duty-tab--active" ) );
				tab.classList.add( "duty-tab--active" );

				if ( tab.dataset.addNicShots === "true" )
				{
					nicToggleLabel.style.display = "flex";
				}
				else
				{
					nicToggleLabel.style.display = "none";
				}
				updateVapeDutyCalculator( );
			});
		});

		inputs.forEach( input =>
		{
			input.addEventListener( "change", updateVapeDutyCalculator );
		});
    } );
}

document.addEventListener( "DOMContentLoaded", initVapeDutyCalculator );